var _path, _ellipse, _ellipse2, _ellipse3, _ellipse4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShotik = function SvgShotik(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m12.125 10.882-.934-.88a2.3 2.3 0 0 1-.714-1.403c-.329-2.788-4.626-2.788-4.954 0A2.3 2.3 0 0 1 4.808 10l-.934.88c-.992.937-.856 2.498.267 3.291.763.54 1.816.576 2.61.077a2.36 2.36 0 0 1 2.497 0c.794.499 1.847.463 2.61-.077 1.123-.793 1.26-2.354.267-3.29"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 13.431,
    cy: 6.934,
    fill: "currentColor",
    rx: 1.704,
    ry: 1.917
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 2.569,
    cy: 6.934,
    fill: "currentColor",
    rx: 1.704,
    ry: 1.917
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 5.763,
    cy: 3.313,
    fill: "currentColor",
    rx: 1.704,
    ry: 1.917
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 10.237,
    cy: 3.313,
    fill: "currentColor",
    rx: 1.704,
    ry: 1.917
  })));
};
export default SvgShotik;